/**
 * Store de gestion du thème (light/dark mode)
 * Détecte automatiquement la préférence système au premier chargement
 * Persiste le choix dans localStorage
 */
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useThemeStore = defineStore(
  'theme',
  () => {
    // null = premier chargement (pas encore de choix utilisateur)
    const isDark = ref<boolean | null>(null)

    /**
     * Applique ou retire la classe .app-dark sur <html>
     */
    function applyTheme(dark: boolean) {
      if (dark) {
        document.documentElement.classList.add('app-dark')
      } else {
        document.documentElement.classList.remove('app-dark')
      }
    }

    /**
     * Initialise le thème au démarrage de l'application
     * - Si premier lancement (isDark === null), détecte prefers-color-scheme
     * - Sinon utilise la valeur persistée
     */
    function init() {
      if (isDark.value === null) {
        // Premier lancement : détecter la préférence système
        const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
        isDark.value = prefersDark
      }
      applyTheme(isDark.value)
    }

    /**
     * Bascule entre light et dark mode
     */
    function toggle() {
      isDark.value = !isDark.value
      applyTheme(isDark.value)
    }

    /**
     * Force un mode spécifique
     */
    function setDark(value: boolean) {
      isDark.value = value
      applyTheme(value)
    }

    return {
      isDark,
      init,
      toggle,
      setDark,
    }
  },
  {
    persist: {
      storage: localStorage,
      pick: ['isDark'],
    },
  },
)
